import { Modal, Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { memo, useEffect, useRef } from "react";
import PdfViewerComponent from "../PdfViewerComponent/PdfViewerComponent";
import DocumentEditorViewer from "../DocumentEditorViewer/DocumentEditorViewer";

type FileUploadModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
  // record: any;
};

function ViewDocumentModal(props: FileUploadModalProps) {
  const documentUrl = useSelector((state: RootState) => state.engageTranslationState.clientReadyState.downLoadUrl);
  const loading = useSelector((state: RootState) => state.engageTranslationState.clientReadyState.fetchDocumentLoading);
  const pdfViewOnlyRef = useRef<HTMLDivElement>(null);
  const wordViewOnlyRef = useRef<HTMLDivElement>(null);
  const customFontState = useSelector((state: RootState) => state.engageTranslationState.customFonts);
  const selectDocumentState = useSelector((state: RootState) => state.engageTranslationState.newTabState.selectedDocument);
  const selectedSingleDocument = useSelector((state: RootState) => state.engageTranslationState.newTabState.selectedTranslatedDocumentID);
  const documentFileType = useSelector((state: RootState) => state.engageTranslationState.clientReadyState.selectedDocumentType);

  console.log(documentUrl);

  const ViewDocumentModalContent = () => {
    if (loading) {
      return (
        <div
          className="d-flex flex-column gap-3 mt-5 justify-content-center align-items-center"
          style={{ height: 1000, textAlign: "center" }}>
          <Spin />
        </div>
      );
    }
    return (
      <div
        className="d-flex flex-column gap-3 mt-5"
        style={{ height: 1000, width: "100%" }}>
        {documentFileType === "pdf" ? (
          <PdfViewerComponent
            refContainer={pdfViewOnlyRef}
            customFonts={customFontState}
            document={documentUrl}
            docId={selectDocumentState.selectedDocumentID}
            documentId={selectedSingleDocument}
          />
        ) : (
          <DocumentEditorViewer
            editable={false}
            document={documentUrl}
            refContainer={wordViewOnlyRef}
            type="modal"
          />
        )}

        {/* <DocumentEditorViewer
          editable={false}
          docId={selectDocumentState.selectedDocumentID}
          documentId={selectedSingleDocument}
          refContainer={wordViewOnlyRef}
        /> */}
      </div>
    );
  };
  //   const FileUploadModalWidth = "30%";
  return (
    <Modal
      //   width={FileUploadModalWidth}
      width={"50%"}
      centered
      zIndex={10000}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      <ViewDocumentModalContent />
    </Modal>
  );
}
function arePropsEqual(oldProps: FileUploadModalProps, newProps: FileUploadModalProps) {
  return oldProps.openState === newProps.openState;
}
export default memo(ViewDocumentModal, arePropsEqual);
